import type { QcHeatmapRange } from '../ColorRamp';
import { useCompositeScene, useViewManager, useScanReviewAppContext } from './ScanReview.hooks';
import constate from 'constate';
import React from 'react';

interface ScanReviewCompleteViewAppProps {
    initialHeatmapRange: QcHeatmapRange;
}

function useScanReviewCompleteViewApp({ initialHeatmapRange }: ScanReviewCompleteViewAppProps) {
    const { lowerJawFactory, upperJawFactory, viewState, displayType, jawDisplayState } = useScanReviewAppContext();
    const [heatMapRange, setHeatMapRange] = React.useState<QcHeatmapRange>(initialHeatmapRange);

    const scene = useCompositeScene(lowerJawFactory, upperJawFactory);
    scene.setDisplayType(displayType, heatMapRange);
    scene.setUpperJawVisibility(jawDisplayState.upper);
    scene.setLowerJawVisibility(jawDisplayState.lower);

    const viewManager = useViewManager(viewState);
    const setHeatMapRangeCallback = React.useCallback(
        (newHeatMapRange: QcHeatmapRange) => {
            scene.updateHeatMapRange(newHeatMapRange.min, newHeatMapRange.max);
            setHeatMapRange(newHeatMapRange);
        },
        [scene, setHeatMapRange],
    );

    return {
        scene,
        viewManager,
        heatMapRange,
        setHeatMapRangeCallback,
    };
}

export const [ScanReviewCompleteViewAppProvider, useScanReviewCompleteViewAppContext] =
    constate(useScanReviewCompleteViewApp);
